module.exports = __webpack_public_path__ + "static/media/first_page_black_24dp.f6c4d788.svg";